import React from 'react';

const SectionPrivacyPolicy = () => {
  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="privacy">
            <h1><center>Terms & Privacy Policy</center></h1>
            <br/>
            <br/>
            <p><strong>Last Updated:</strong> March 6, 2022</p>
            <h4>1. Introduction</h4>
            <p>Welcome to the V’Peters Family Scholarship website. By accessing and using this website, you agree to comply with these Terms & Privacy Policy provisions. If you do not agree, please discontinue use of the website.</p>

            <h4>2. Eligibility & Use</h4>
            <ul>
              <li>This website is intended for applicants, donors, and supporters of the V’Peters Family Scholarship.</li>
              <li>Users must provide accurate and truthful information when applying for scholarships, submitting donations, or registering for updates.</li>
              <li>Unauthorized access, tampering, or misuse of website data is strictly prohibited.</li>
            </ul>

            <h4>3. Scholarship Application Process</h4>
            <ul>
              <li>All applications must be submitted through the official portal.</li>
              <li>Meeting eligibility criteria does not guarantee scholarship approval.</li>
              <li>Submitted documents must be genuine; falsification may result in disqualification.</li>
              <li>V’Peters Family Scholarship reserves the right to modify or discontinue the scholarship program without prior notice.</li>
            </ul>

            <h4>4. Privacy Policy</h4>
            <h5>4.1 Information We Collect</h5>
            <ul>
              <li><strong>Personal Information:</strong> Name, email, phone number, mailing address, and school details (for applicants).</li>
              <li><strong>Payment Information:</strong> We collect billing details for donations, but do not store credit/debit card information. Payments are securely processed via third-party providers.</li>
              <li><strong>Browsing Data:</strong> Website analytics such as IP addresses, cookies, and user interactions to improve services.</li>
            </ul>

            <h5>4.2 How We Use Your Information</h5>
            <ul>
              <li>To process scholarship applications and communicate with applicants.</li>
              <li>To process donations and issue tax receipts.</li>
              <li>To send newsletters, updates, and event notifications (only if opted-in).</li>
              <li>To improve website security, functionality, and user experience.</li>
            </ul>

            <h5>4.3 Data Protection & Sharing</h5>
            <ul>
              <li>We do not sell or trade your personal information.</li>
              <li>Limited information may be shared with trusted third-party service providers for processing payments and managing application databases.</li>
              <li>Personal data is securely stored and protected against unauthorized access.</li>
            </ul>

            <h4>5. Donations & Refund Policy</h4>
            <h5>5.1 Donations</h5>
            <ul>
              <li>Donations support student scholarships and related educational initiatives.</li>
              <li>Options include one-time, monthly, quarterly, and yearly contributions.</li>
            </ul>

            <h5>5.2 Refund Policy</h5>
            <ul>
              <li><strong>One-Time Donations:</strong> Non-refundable unless made in error. Refund requests must be submitted within 7 days.</li>
              <li><strong>Recurring Donations:</strong> Future donations can be canceled anytime, but past payments are non-refundable.</li>
              <li>Refund requests: <a href="mailto:contact@vpeters.org">contact@vpeters.org</a> with proof of donation.</li>
            </ul>

            <h5>5.3 Tax Receipts</h5>
            <ul>
              <li>Immediate tax receipts are sent via email for each donation.</li>
              <li>Annual summaries may be provided for tax purposes.</li>
              <li>V’Peters Family Scholarship is a registered 501(c)(3) nonprofit organization.</li>
            </ul>

            <h4>6. Cookies & Tracking Technologies</h4>
            <p>This website uses cookies to enhance user experience. By using this site, you consent to cookie use. Users can manage cookie settings via browser preferences.</p>

            <h4>7. Limitation of Liability</h4>
            <p>V’Peters Family Scholarship is not liable for data loss, cyberattacks, or service interruptions. Scholarship funds are subject to availability and eligibility.</p>

            <h4>8. Updates to Terms & Privacy Policy</h4>
            <p>We may update this policy from time to time. Any changes will be posted with the updated date.</p>

            <h4>9. Contact Us</h4>
            <p>If you have any questions, please contact us:</p>
            <ul>
              <li>Email: <a href="mailto:contact@vpeters.org">contact@vpeters.org</a></li>
              <li>Website: <a href="https://www.vpeters.org">www.vpeters.org</a></li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionPrivacyPolicy;